'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const AddPDFAttachmentIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="AddPDFAttachmentIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.5 17.5C11.5 19.0913 12.1321 20.6174 13.2574 21.7426C14.3826 22.8679 15.9087 23.5 17.5 23.5C19.0913 23.5 20.6174 22.8679 21.7426 21.7426C22.8679 20.6174 23.5 19.0913 23.5 17.5C23.5 15.9087 22.8679 14.3826 21.7426 13.2574C20.6174 12.1321 19.0913 11.5 17.5 11.5C15.9087 11.5 14.3826 12.1321 13.2574 13.2574C12.1321 14.3826 11.5 15.9087 11.5 17.5Z"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 14.5V20.5"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5 17.5H14.5"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 23.5H1.5C1.23478 23.5 0.98043 23.3946 0.792893 23.2071C0.605357 23.0196 0.5 22.7652 0.5 22.5V1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H14.793C15.0582 0.500057 15.3125 0.605451 15.5 0.793L19.207 4.5C19.3946 4.68749 19.4999 4.9418 19.5 5.207V8.5"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.42308 5.21154C6.42308 5.53286 6.29543 5.84102 6.06823 6.06823C5.84102 6.29543 5.53286 6.42308 5.21154 6.42308H4V4H5.21154C5.53286 4 5.84102 4.12764 6.06823 4.35485C6.29543 4.58206 6.42308 4.89022 6.42308 5.21154Z"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 8.84495V6.42188"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.03857 4C8.68121 4 9.29753 4.25529 9.75195 4.7097C10.2064 5.16412 10.4617 5.78044 10.4617 6.42308C10.4617 7.06572 10.2064 7.68204 9.75195 8.13645C9.29753 8.59087 8.68121 8.84615 8.03857 8.84615V4Z"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0771 8.84615V4.80769C12.0771 4.59348 12.1622 4.38804 12.3137 4.23657C12.4652 4.0851 12.6706 4 12.8848 4H14.5002"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0771 6.42188H13.6925"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

AddPDFAttachmentIcon.propTypes = {
  sx: PropTypes.object
}
